import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

import { AppInfo } from "./app-info.model";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-info",
    templateUrl: "./app-info.component.html",
    styleUrls: ["./app-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon]
})
export class AppInfoComponent {
    @Input() public value: AppInfo;
    @Output() public close = new EventEmitter<AppInfo>();
    @HostBinding("class") public cssClass = "backgroundcolor2";

    public onClose(event: MouseEvent): void {
        event.preventDefault();
        this.close.emit(this.value);
    }
}
